import React from "react";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import { useTheme } from "@mui/material";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useEffect } from "react";

const IconLabelComponent = ({
  item,
  isSelected,
  onChange = () => { },
  width = 105,
  direction = 'row',
  icon = <ThermostatIcon style={{ width: 22, height: 22, color: 'white' }} />,
}) => {
  const theme = useTheme();
  const { t } = useTranslation()
  const [backgroundColor, setBackgroundColor] = useState('transparent')

  useEffect(() => {
    if (isSelected) {
      setBackgroundColor(theme.palette.secondary.main)
    } else {
      setBackgroundColor("transparent")
    }
  }, [isSelected, theme])
  return (
    <Box sx={{ display: "flex", flexDirection: direction }} >
      <Box
        pt={1.6}
        color="white"
        sx={{
          textShadow: "0px 0px 4px black",
          width: width,
          fontWeight: "bold",
          fontSize: 13,
        }}
        onClick={onChange}
      >
        <Typography
          align="right"
          pr={1}
          pt={0.1}
          pb={0.1}
          sx={{
            boxShadow: isSelected ? "0 0 4px 0 black" : 0,
            backgroundColor: backgroundColor,
            "&:hover": {
              backgroundColor: backgroundColor,
            },
            borderRadius: 2
          }}

        >
          {t(item.label)}
        </Typography>
      </Box>

      <Box
        onClick={onChange}
        sx={{
          backgroundColor: backgroundColor,
          "&:hover": {
            backgroundColor: backgroundColor,
          },
          padding: 0,
          boxShadow: isSelected ? "0 0 4px 0 black" : 0,
          height: 22,
          width: 22,
          marginTop: 1.5,
          marginBottom: 1,
          color: "white",
          borderRadius: 2,
          zIndex: 999
        }}
      >
        {icon}
      </Box>
    </Box>
  );
};

export default IconLabelComponent;
